import config from "./configOrigin.jsx";
import links from "./config.json";

export const identityTypes = [
  {
    id: "teamName",
    label: "teamName",
    value: "teamName",
    description: ""
  },
  {
    id: "alias",
    label: "alias",
    value: "alias",
    description: ""
  }
];

export const yesNoOptions = [
  {
    id: "yes",
    label: "Yes",
    value: true,
    description: ""
  },
  {
    id: "no",
    label: "No",
    value: false,
    description: ""
  }
];

export const simTTOptions = [
  {
    id: "sim",
    label: "SIM",
    value: true,
    description: ""
  },
  {
    id: "tt",
    label: "TT",
    value: false,
    description: ""
  }
];

export const productGroupOptions = [
  {
    id: "AWS Commerce Platform",
    label: "AWS Commerce Platform",
    value: "AWS Commerce Platform",
    description: ""
  }
];

export const orgs = {
  "AWS Commerce Platform": [
    {
      id: "PRET",
      label: "PRET",
      value: "PRET",
      description: ""
    },
    {
      id: "Bill Generation",
      label: "Bill Generation",
      value: "Bill Generation",
      description: ""
    },
    {
      id: "FinX",
      label: "FinX",
      value: "FinX",
      description: ""
    },
    {
      id: "Insights",
      label: "Insights & Enterprise Tools",
      value: "Insights",
      description: ""
    },
    {
      id: "Misc",
      label: "Misc",
      value: "Misc",
      description: ""
    }
  ]
};

export const oncallLink = "https://oncall.corp.amazon.com";

export const PAGE_EMAIL_SUBJECT = "Include A Subject For Page";
export const PAGE_EMAIL_BODY = "Include a reason for this page...";

export const navigationItems = [
  { type: "link", text: "PRET", href: "#pret" },
  { type: "link", text: "Bill Generation", href: "#bill-generation" },
  { type: "link", text: "FinX", href: "#finx" },
  { type: "link", text: "Insights & Enterprise Tools", href: "#insights" },
  { type: "link", text: "Misc", href: "#misc" },
  { type: "divider" },
  {
    "type": "section",
    "text": "Oncall Tool Resources",
    "items": [
      {
        "type": "link",
        "text": "Getting Started",
        "href": links.onboardingLink,
        "external": true
      },
      {
        "type": "link",
        "text": "Feedback",
        "href": links.feedbackLink,
        "external": true
      }
    ]
  },
  { type: "divider" },
  {
    "type": "section",
    "text": "External Links",
    "items": [
      {
        "type": "link",
        "text": "CP One",
        "href": config.cpOne,
        "external": true
      },
      {
        "type": "link",
        "text": "Bingo",
        "href": config.bingo,
        "external": true
      }
    ]
  },
  { type: "divider" }
];

export const pret = {};
export const billGeneration = {};
export const finX = {};
export const insights = {};
export const misc = {};

export const orgMap = {
  "PRET": pret,
  "Bill Generation": billGeneration,
  "FinX": finX,
  "Insights": insights,
  "Misc": misc
};

export const secondaries = {};

export const productGroups = {
  "AWS Commerce Platform": [pret, billGeneration, finX, insights, misc]
};

export const orgGroups = {
  "AWS Commerce Platform": ["PRET", "Bill Generation", "FinX", "Insights", "Misc"]
};

export const MAX_CHAR = 256;

export const SUCCESS_MESSAGE = "Page was sent successfully!";



// WEBPACK FOOTER //
// ./src/data/constData.js